import AgentService from "../../api/agent.service";
import Cookies from "js-cookie";

// export const namespaced = true

const state = {
  agentProfile: Cookies.getJSON("agentProfile"),
};

const getters = {
  IsAgentProfileAvailable: (state) => {
    // console.log("state.agentProfile | ", state.agentProfile)
    return state.agentProfile;
  },
};

const actions = {
	getAgentProfile({ rootState, commit }) {
		const { authToken } = rootState.auth;
		return AgentService.getAgentProfileAsync(authToken).then(
			(user) => {
				commit('setAgentProfile', user.data);
				Cookies.set('agentProfile', user.data, { expires: 1 });
				return Promise.resolve(user);
			},
			(error) => {
				commit('setAgentProfile', null);
				return Promise.reject(error);
			}
		);
	},
	setAgentProfile({ commit }, userProfile) {
		commit('setAgentProfile', userProfile);
	},
	getRetailCenterProfile({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getRetailCenterProfileAsync(authToken).then(
			(user) => {
				return Promise.resolve(user);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getDeliveryPickupPoints({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.getDeliveryPickupPointsAsync(
			authToken,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getDeliveryWindows({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getDeliveryWindowsAsync(authToken).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getProductGroups({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getProductGroupsAsync(authToken).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getProductCategories({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getProductCategoriesAsync(authToken, id).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addCategoryToShop({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;

		return AgentService.addCategoryToShopAsync(
			authToken,
			agentProfile.clientId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getClientProducts({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data.searchBy['clientId'] = agentProfile.clientId;
		return AgentService.getClientProductsAsync(authToken, request_data).then(
			(products) => {
				return Promise.resolve(products);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	setProductStatus({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.setProductStatusAsync(authToken, request_data).then(
			(products) => {
				return Promise.resolve(products);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getSystemProducts({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getSystemProductsAsync(authToken).then(
			(products) => {
				return Promise.resolve(products);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getAgentInventory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.getAgentInventoryAsync(authToken, request_data).then(
			(inventories) => {
				return Promise.resolve(inventories);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	finalAgentInventory({ dispatch }, request_data) {
		let products = dispatch('getClientProducts', request_data);
		let inventory = dispatch('getAgentInventory', request_data);
		let campaigns = dispatch('getPreOrderCampaigns');
		let getAgentAllOrderRequests = dispatch('getAgentAllOrderRequests');
		let getInvoicesData = dispatch('invoices/getInvoices', {
			page: -1,
			perPage: -1,
			searchBy: {},
			sortBy: {},
		});
		let getWareHousTransferData = dispatch('getWareHousTransferData', '');
		return Promise.all([
			products,
			inventory,
			campaigns,
			getAgentAllOrderRequests,
			getInvoicesData,
			getWareHousTransferData,
		]).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				console.log('Error | ', error);
				return Promise.reject(error);
			}
		);
	},

	finalAgentInventorySearchSort({ dispatch }, request_data) {
		let request = {
			page: -1,
			perPage: -1,
		};
		let products = dispatch('getClientProducts', request_data);
		let inventory = dispatch('getAgentInventory', request);

		return Promise.all([products, inventory]).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				console.log('Error | ', error);
				return Promise.reject(error);
			}
		);
	},

	getAllManufacturers({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAllManufacturersAsync(authToken).then(
			(brand) => {
				return Promise.resolve(brand);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getAllSuppliers({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAllSuppliersAsync(authToken).then(
			(brand) => {
				return Promise.resolve(brand);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllCategories({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAllCategoriesAsync(authToken).then(
			(category) => {
				return Promise.resolve(category);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getSubCategoriesByCategoryId({ rootState }, categoryId) {
		const { authToken } = rootState.auth;
		return AgentService.getSubCategoriesByCategoryIdAsync(
			authToken,
			categoryId
		).then(
			(category) => {
				return Promise.resolve(category);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	finalCategoryManufacturerSupplierList({ dispatch }) {
		let manufacturers = dispatch('getAllManufacturers');
		let categories = dispatch('getAllCategories');
		let suppliers = dispatch('getAllSuppliers');

		return Promise.all([manufacturers, categories, suppliers]).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				console.log('Error | ', error);
				return Promise.reject(error);
			}
		);
	},

	getAgentCustomers({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAgentCustomersAsync(authToken).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getAgentAllOrderRequests({ rootState }) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		return AgentService.getAgentAllOrderRequestsAsync(
			authToken,
			agentProfile.clientId
		).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getAgentAllPreOrderRequests({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data.searchBy = {
			clientId: clientId,
		};
		return AgentService.getAgentAllPreOrderRequestsAsync(
			authToken,
			request_data
		).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getClientUsersRequests({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data.searchBy = {
			clientId: clientId,
		};
		return AgentService.getClientUsersRequestsAsync(
			authToken,
			request_data
		).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	confirmNewOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.confirmNewOrderAsync(authToken, request_data).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	declineNewOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.declineNewOrderAsync(authToken, request_data).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAgentPurchasedOrders({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.getAgentPurchasedOrderAsync(
			authToken,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAgentUsers({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAgentUsersAsync(authToken).then(
			(customers) => {
				return Promise.resolve(customers);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllRegion({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAllRegionAsync(authToken).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllSubRegionById({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getAllSubRegionByIdAsync(authToken, id).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllCommunitiesById({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getAllCommunitiesByIdAsync(authToken, id).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllSubRegion({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAllSubRegionAsync(authToken).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getDistrictById({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getDistrictByIdAsync(authToken, id).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getTownById({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getTownByIdAsync(authToken, id).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getProductInventory({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getProductInventoryAsync(authToken, id).then(
			(regions) => {
				return Promise.resolve(regions);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addNewStock({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let retailCenterId = agentProfile.retailCentreId;
		return AgentService.addNewStockAsync(
			authToken,
			retailCenterId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addNewGroup({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addNewGroupAsync(authToken, request_data);
		return response;
	},

	addRegion({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addNewRegionAsync(authToken, request_data);
		return response;
	},

	addSubRegion({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addNewSubRegionAsync(authToken, request_data);
		return response;
	},

	addCommunity({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addCommunityAsync(authToken, request_data);
		return response;
	},

	updateRegion({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.updateRegionAsync(authToken, request_data);
		return response;
	},

	updateGroup({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.updateGroupAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},

	addCategory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addCategoryAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},

	addProductSupplier({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addProductSupplierAsync(
			authToken,
			request_data
		);
		return response;
	},

	addProductManufacturer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.addProductManufacturerAsync(
			authToken,
			request_data
		);
		return response;
	},

	updateCategory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.updateCategoryAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},

	updateProductSupplier({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.updateProductSupplierAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},

	getBackOrdersData({ rootState }) {
		const { authToken } = rootState.auth;
		const response = AgentService.getBackOrdersDataAsync(authToken);
		return response;
	},

	updateProductManufacturer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = AgentService.updateProductManufacturerAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},

	addNewProduct({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data['clientId'] = clientId;
		return AgentService.addNewProductAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getPurchasedOrderAsync({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data['clientId'] = clientId;
		return AgentService.getPurchasedOrderAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getWaybillOrderAsync({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data['clientId'] = clientId;
		return AgentService.getWaybillOrderAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	updateProduct({ rootState }, final_request_data) {
		const { authToken } = rootState.auth;
		return AgentService.updateProductAsync(authToken, final_request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	setProductPrice({ rootState }, final_request_data) {
		const { authToken } = rootState.auth;
		return AgentService.setProductPriceAsync(
			authToken,
			final_request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	deleteProduct({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.deleteProductAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getTopProducts({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		return AgentService.getTopProductsAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getZoneOrders({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		return AgentService.getZoneOrdersAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	generatePurcharseOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		return AgentService.generatePurcharseOrderAsync(
			authToken,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	generateWaybillOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = agentProfile.clientId;
		return AgentService.generateWaybillOrderAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getPreOrdersProductsAsync({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data.searchBy['clientId'] = agentProfile.clientId;
		return AgentService.getPreOrdersProductsAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getOverallReport({ rootState }, requestData) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		return AgentService.getOverallReportAsync(
			authToken,
			agentProfile.clientId,
			requestData
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getSupplierDetails({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getSupplierDetailsAsync(authToken, id).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getSalesReport({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data['clientId'] = clientId;
		return AgentService.getSalesReportAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	canFulfillProduct({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data.data['clientId'] = agentProfile.clientId;
		return AgentService.canFulfillProductAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addSupplier({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data['clientId'] = clientId;
		return AgentService.addSupplierAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addManufacturer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data['clientId'] = clientId;
		return AgentService.addManufacturerAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	async getDailySales({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getDailySalesAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getAllDistributionCenters({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getAllDistributionCentersAsync(
			authToken
		);
		return response;
	},

	async getOverviewTopProducts({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getOverviewTopProductsAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getSalesByLocation({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getSalesByLocationAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getSalesByCategory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getSalesByCategoryAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getSalesByCustomer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getSalesByCustomerAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async addStockToWarehouse({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.addStockToWarehouseAsync(
			authToken,
			request_data
		);
		return response;
	},

	async addSubCustomer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.addSubCustomer(authToken, request_data);
		return response;
	},

	getSummaryPreOrderProduct({ dispatch }, request_data) {
		let topProducts = dispatch('getTopProducts', request_data.topProductData);
		let salesReport = dispatch('getSalesReport', request_data.barSalesData);

		return Promise.all([topProducts, salesReport]).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				console.log('Error | ', error);
				return Promise.reject(error);
			}
		);
	},

	getOverviewData({ dispatch }, request_data) {
		let topProducts = dispatch('getToTalRequest');
		let salesReport = dispatch('getOverallReport', request_data.request_data_1);
		let preOrders = dispatch(
			'getPreOrdersProductsAsync',
			request_data.request_data_2
		);
		let dailySales = dispatch('getDailySales', request_data.request_data_3);
		let overViewTopProducts = dispatch(
			'getOverviewTopProducts',
			request_data.request_data_1
		);

		return Promise.all([
			topProducts,
			salesReport,
			preOrders,
			dailySales,
			overViewTopProducts,
		]).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				console.log('Error | ', error);
				return Promise.reject(error);
			}
		);
	},

	async getClientBankDetail({ rootState }) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getClientBankDetailAsync(
			authToken,
			agentProfile.clientId
		);
		return response;
	},

	async getMonthlySales({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getMonthlySalesAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getFinanceOverview({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getFinanceOverviewAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getSalesReports({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getSalesReportsAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getDailySalesSummary({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getDailySalesSummaryAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getMonthlySalesSummary({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getMonthlySalesSummaryAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getSalesReportsOverview({ dispatch }, final_request) {
		let getSalesReports = dispatch(
			'getSalesReports',
			final_request.request_data
		);
		let getDailySalesSummary = dispatch(
			'getDailySalesSummary',
			final_request.request_data
		);
		let response = await Promise.all([getSalesReports, getDailySalesSummary]);
		return response;
	},

	async getAllRetailers({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getAllRetailersAsync(authToken);
		return response;
	},

	async getAllCommunities({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getAllCommunitiesAsync(authToken);
		return response;
	},

	async addNewCustomer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.addNewCustomerAsync(
			authToken,
			request_data
		);
		return response;
	},

	async updateNewCustomer({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.updateNewCustomerAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},

	async updateCustomerStatus({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.updateCustomerStatusAsync(
			authToken,
			request_data.id,
			request_data.IsActive
		);
		return response;
	},

	async getRetailCenterExtraDetails({ rootState }, retailCenterId) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getRetailCenterDetailsAsync(
			authToken,
			retailCenterId
		);
		return response;
	},

	async getRetailShopCategory({ rootState }, retailCenterId) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getRetailShopCategoryAsync(
			authToken,
			retailCenterId
		);
		return response;
	},

	async getRetailCenterCustomers({ rootState }, payload) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getRetailCustomersAsync(
			authToken,
			payload
		);
		return response;
	},

	async getRetailOrders({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getRetailOrdersAsync(
			authToken,
			request_data
		);
		return response;
	},

	async getRetailerAndCategoryAndOrders({ dispatch }, request_data) {
		let getRetailCenterExtraDetails = dispatch(
			'getRetailCenterExtraDetails',
			request_data.retailCenterId
		);
		let getRetailShopCategory = dispatch(
			'getRetailShopCategory',
			request_data.retailCenterId
		);
		let getRetailerOrders = dispatch(
			'getRetailerOrders',
			request_data.locationId
		);
		let getAllRetailers = dispatch('getAllRetailers');
		let getRetailCenterCustomers = dispatch(
			'getRetailCenterCustomers',
			request_data.payload
		);

		let response = await Promise.all([
			getRetailCenterExtraDetails,
			getRetailShopCategory,
			getRetailerOrders,
			getAllRetailers,
			getRetailCenterCustomers,
		]);
		return response;
	},

	async updateCustomerTier({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.updateCustomerTierAsync(
			authToken,
			request_data.id,
			request_data.tier
		);
		return response;
	},

	async getRetailerOrders({ rootState }, locationId) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getRetailerOrdersAsync(
			authToken,
			locationId
		);
		return response;
	},

	async getAllStockAdjustment({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getAllStockAdjustmentAsync(authToken);
		return response;
	},

	async addBackOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.addBackOrderAsync(
			authToken,
			request_data
		);
		return response;
	},

	async getBackOrderById({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getBackOrderByIdAsync(
			authToken,
			request_data.id
		);
		return response;
	},

	async getAllWarehousesData({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getAllWarehousesAsync(authToken);
		return response;
	},

	async updateBackOrderLines({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.updateBackOrderLinesAsync(
			authToken,
			request_data.backOrderId,
			request_data.backOrderLineId,
			request_data.data
		);
		return response;
	},

	async updateBackOrder({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.updateBackOrderAsync(
			authToken,
			request_data.backOrderId,
			request_data.data
		);
		return response;
	},

	async addNewStockAdjustment({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.addNewStockAdjustmentAsync(
			authToken,
			request_data
		);
		return response;
	},

	async updateStockAdjustment({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const response = await AgentService.updateStockAdjustmentAsync(
			authToken,
			request_data.id,
			request_data.data
		);
		return response;
	},
	async getAllInventoryProducts({ rootState }, locationId) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getAllInventoryProductsAsync(
			authToken,
			locationId
		);
		return response;
	},

	async getRetailerAndProducts({ dispatch }, request_data) {
		let getClientProducts = dispatch('getClientProducts', request_data);
		let getAllRetailers = dispatch('getAllRetailers');
		let response = await Promise.all([getClientProducts, getAllRetailers]);
		return response;
	},

	async getClientProductAndDistCenters({ dispatch }, request_data) {
		let getClientProducts = dispatch('getClientProducts', request_data);
		let getAllDistributionCenters = dispatch('getAllDistributionCenters');
		let response = await Promise.all([
			getClientProducts,
			getAllDistributionCenters,
		]);
		return response;
	},

	async getAllProductsMgtData({ dispatch }) {
		let getAllGroups = dispatch('getAllGroups');
		let getAllCategories = dispatch('getAllCategories');
		let getAllSuppliers = dispatch('getAllSuppliers');
		let getAllManufacturers = dispatch('getAllManufacturers');

		let response = await Promise.all([
			getAllGroups,
			getAllCategories,
			getAllSuppliers,
			getAllManufacturers,
		]);
		return response;
	},

	async getAllWarehouseMgtData({ dispatch }, locationId) {
		let getAllWareHouseInventories = dispatch(
			'distroCenter/FetchWareHouseInventories'
		);
		let getWareHouseDeliveriesData = dispatch(
			'getWareHouseDeliveriesData',
			locationId
		);
		let getWareHousTransferData = dispatch(
			'getWareHousTransferData',
			locationId
		);

		let getGeneratedPurchaseOrders = dispatch(
			'purchaseOrder/getGeneratedPurchaseOrders',
			{
				page: -1,
				perPage: -1,
				searchBy: {},
				sortBy: {},
			}
		);

		let response = await Promise.all([
			getAllWareHouseInventories,
			getWareHouseDeliveriesData,
			getWareHousTransferData,
			getGeneratedPurchaseOrders,
		]);
		return response;
	},

	async getWareHouseDeliveriesData({ rootState }, locationId) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getWareHouseDeliveriesAsync(
			authToken,
			locationId
		);
		return response;
	},

	async getWareHousTransferData({ rootState }, locationId) {
		const { authToken } = rootState.auth;
		const response = await AgentService.getWareHousTransferDataAsync(
			authToken,
			locationId
		);
		return response;
	},

	async getMonthlySalesReportsOverview({ dispatch }, final_request) {
		let getSalesReports = dispatch(
			'getSalesReports',
			final_request.request_data
		);
		let getMonthlySalesSummary = dispatch(
			'getMonthlySalesSummary',
			final_request.request_data
		);
		let response = await Promise.all([getSalesReports, getMonthlySalesSummary]);
		return response;
	},

	async getPayoutTransactionHistory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.getPayoutTransactionHistoryAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	getFinancesData({ dispatch }, request_data) {
		let getMonthlySales = dispatch('getMonthlySales', request_data);
		let getFinanceOverview = dispatch('getFinanceOverview', request_data);
		let getPayoutTransactionHistory = dispatch('getPayoutTransactionHistory');

		return Promise.all([
			getMonthlySales,
			getFinanceOverview,
			getPayoutTransactionHistory,
		]).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				console.log('Error | ', error);
				return Promise.reject(error);
			}
		);
	},

	async financeRequest({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.financeRequestAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async updateClientBankDetail({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.updateClientBankDetailAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async createClientBankDetail({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		const response = await AgentService.createClientBankDetailAsync(
			authToken,
			agentProfile.clientId,
			request_data
		);
		return response;
	},

	async getInventoryBalByDistCenter({ rootState }, request_data) {
		const { authToken } = rootState.auth;

		const response = await AgentService.getInventoryBalByDistCenterAsync(
			authToken,
			request_data.locationId
		);
		return response;
	},

	async addInventoryTransfer({ rootState }, request_data) {
		const { authToken } = rootState.auth;

		const response = await AgentService.addInventoryTransferAsync(
			authToken,
			request_data.destinationLocationId,
			request_data.data
		);
		return response;
	},

	async getDistributionCenterProducts({ dispatch }, final_request) {
		let getClientProducts = dispatch(
			'getClientProducts',
			final_request.request_data_1
		);
		let getInventoryBalByDistCenter = dispatch(
			'getInventoryBalByDistCenter',
			final_request.request_data_2
		);
		let response = await Promise.all([
			getClientProducts,
			getInventoryBalByDistCenter,
		]);
		return response;
	},

	getToTalRequest({ rootState }) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;

		return AgentService.getToTalRequestAsync(
			authToken,
			agentProfile.clientId
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addInventoryRequest({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let retailCenterId = agentProfile.retailCentreId;
		return AgentService.addInventoryRequestAsync(
			authToken,
			retailCenterId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addNewClientUser({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data.isClient ? (request_data.data.clientId = clientId) : '';
		return AgentService.addNewClientUserAsync(
			authToken,
			request_data.data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	updateClientUser({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let clientId = agentProfile.clientId;
		request_data.isClient ? (request_data.data.clientId = clientId) : '';
		return AgentService.updateClientUserAsync(
			authToken,
			request_data.userId,
			request_data.data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	changeUserPassword({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.changeUserPasswordAsync(
			authToken,
			request_data.userId,
			request_data.data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllGroups({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getAllGroupsAsync(authToken).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getInventoryReport({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		return AgentService.getInventoryReportAsync(
			authToken,
			agentProfile.clientId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getWaybillReport({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data.searchBy = {
			clientId: agentProfile.clientId,
		};
		return AgentService.getWaybillReportAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getPurchasedOrderReport({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		request_data['clientId'] = request_data.searchBy = {
			clientId: agentProfile.clientId,
		};
		return AgentService.getPurchasedOrderReportAsync(
			authToken,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getPreOrderCampaigns({ rootState }) {
		const { authToken } = rootState.auth;
		return AgentService.getPreOrderCampaignsAsync(authToken).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addOnboardingInfo({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let retailCenterId = agentProfile.retailCentreId;
		return AgentService.addOnboardingInfoAsync(
			authToken,
			retailCenterId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addPreOrderProduct({ rootState }, preOrderCampaignId, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.addPreOrderProductAsync(
			authToken,
			preOrderCampaignId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getPreOrderProducts({ rootState }, preOrderCampaignId) {
		const { authToken } = rootState.auth;
		return AgentService.getPreOrderProductsAsync(
			authToken,
			preOrderCampaignId
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getAllProducts({ rootState }, preOrderCampaignId) {
		const { authToken } = rootState.auth;
		return AgentService.getAllProductAsync(authToken, preOrderCampaignId).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addProductDetails({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let retailCenterId = agentProfile.retailCentreId;
		return AgentService.addProductDetailsAsync(
			authToken,
			retailCenterId,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	updateRetailCentreDetails({ rootState, dispatch }, request_data) {
		// console.log('rootState  | ', rootState)
		const { authToken } = rootState.auth;
		const { agentProfile } = rootState.agentProfile;
		let retailCenterId = agentProfile.retailCentreId;
		return AgentService.updateRetailCentreDetailsAsync(
			authToken,
			retailCenterId,
			request_data
		).then(
			(response) => {
				// dispatch()
				dispatch('getRetailCenterDetails', null, { root: true });
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	uploadProductImage({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.uploadProductImageAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
	getAllProductById({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getAllProductByIdAsync(authToken, id).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	deleteProductImage({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.deleteProductImageAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addProductInventory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.addProductInventoryAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	updateProductInventory({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.updateProductInventoryAsync(
			authToken,
			request_data
		).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getSalesAgents({ rootState }, request_data) {
		const { authToken } = rootState.auth;
		return AgentService.getSalesAgentsAsync(authToken, request_data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	getPoultries({ rootState }, id) {
		const { authToken } = rootState.auth;
		return AgentService.getPoultryAsync(authToken, id).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},

	addPoultry({ rootState }, request) {
		const { authToken } = rootState.auth;
		return AgentService.addPoultyAsync(authToken, request).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				return Promise.reject(error);
			}
		);
	},
};

const mutations = {
  setAgentProfile: (state, agentProfile) => {
    state.agentProfile = agentProfile;
  },
};

export default {
	state,
	getters,
	actions,
	mutations,
};
